import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
import de from "./locale/de.json";
import en from "./locale/en.json";
import es from "./locale/es.json";
import fr from "./locale/fr.json";
import pt from "./locale/pt.json";
import zh from "./locale/zh.json";

Vue.use(VueI18n);

const messages = { en, es, pt, fr, de, zh };

function getUserLocale() {
  let locale = null;

  try {
    if (navigator.language) {
      locale = navigator.language.split("-")[0].toLowerCase();
    }
  } catch (error) {
    console.log(error);
  }

  if (!Object.keys(messages).includes(locale)) {
    locale = "en";
  }

  store.dispatch("setLocale", locale);

  return locale;
}

function setHtmlLang(locale) {
  try {
    const html = document.documentElement;
    html.setAttribute("lang", locale);
  } catch (err) {
    console.log(err);
  }
}

const pageLocale = store.getters.locale || getUserLocale();

setHtmlLang(pageLocale);

const i18n = new VueI18n({
  locale: pageLocale,
  messages: messages
});

store.subscribeAction({
  after: (action, state) => {
    if (action.type === "setLocale") {
      i18n.locale = state.locale;
      setHtmlLang(state.locale);
    }
  }
});

export default i18n;
